/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductPriceResponseDto
 */
export interface ProductPriceResponseDto {
    /**
     * Price ID
     * @type {number}
     * @memberof ProductPriceResponseDto
     */
    id: number;
    /**
     * Price amount
     * @type {number}
     * @memberof ProductPriceResponseDto
     */
    price: number;
    /**
     * Currency
     * @type {string}
     * @memberof ProductPriceResponseDto
     */
    currency: ProductPriceResponseDtoCurrencyEnum;
    /**
     * Created timestamp
     * @type {Date}
     * @memberof ProductPriceResponseDto
     */
    createdAt: Date;
    /**
     * Updated timestamp
     * @type {Date}
     * @memberof ProductPriceResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const ProductPriceResponseDtoCurrencyEnum = {
    Egp: 'EGP',
    Sar: 'SAR',
    Mad: 'MAD'
} as const;
export type ProductPriceResponseDtoCurrencyEnum = typeof ProductPriceResponseDtoCurrencyEnum[keyof typeof ProductPriceResponseDtoCurrencyEnum];


/**
 * Check if a given object implements the ProductPriceResponseDto interface.
 */
export function instanceOfProductPriceResponseDto(value: object): value is ProductPriceResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ProductPriceResponseDtoFromJSON(json: any): ProductPriceResponseDto {
    return ProductPriceResponseDtoFromJSONTyped(json, false);
}

export function ProductPriceResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductPriceResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'price': json['price'],
        'currency': json['currency'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ProductPriceResponseDtoToJSON(value?: ProductPriceResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'price': value['price'],
        'currency': value['currency'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

